import { useState, useEffect } from 'react';

import { IFlightSchedule } from '../../../globals/interfaces';
import apiClient from '../../../apiClient';

export default function useFlightData (flightDate: string, s_unit: string) {
    const [flights, setFlights] = useState<Array<IFlightSchedule>>([]);

    useEffect(() => {
        const getFlights = async () => {
            const s_origin = s_unit.substring(1, 4);
            const res = await apiClient.get(`/booking/flights?flightDate=${flightDate}&s_origin=${s_origin}`);
            if (res.status === 200) {
                setFlights(res.data);
            }
        }
        getFlights();
    }, [flightDate, s_unit]);

    return {
        flights
    }
}